import {
  primaryEntityActionButtonClass,
} from '@/components/ui/entityActionButtonClasses'

export const PAY_FIELD =
    'rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-sm transition placeholder:text-slate-400 focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/20 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500'

/** Matches Property Edit header Save. */
export const PAY_BTN_PRIMARY = primaryEntityActionButtonClass

export const PAY_LINK =
    'text-sm font-medium text-[rgb(21_151_255)] underline-offset-2 transition hover:text-[#0d7acc] hover:underline'

export const PROP_LABEL = 'mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500'

export const PROP_SECTION_TITLE =
    'mb-4 text-xs font-semibold uppercase tracking-wider text-slate-500'

export const PROP_INNER_CARD =
    'rounded-xl border border-slate-200/80 bg-gradient-to-b from-slate-50/50 to-white px-4 py-4 sm:px-5 sm:py-5'
